import CardsList from "@/components/cardsList";
import { ONEMIND_PHYSICAL_LABS_CONSTANTS } from "./constants";

const BenefitsComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      title={ONEMIND_PHYSICAL_LABS_CONSTANTS.title}
      desc={ONEMIND_PHYSICAL_LABS_CONSTANTS.desc}
      list={ONEMIND_PHYSICAL_LABS_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
    />
  );
};

export default BenefitsComponent;
